import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Layers,
  Truck,
  Sun,
  MapPin,
  GitCommitVertical,
  ShieldAlert,
  Gauge,
  PaintBucket,
  ChevronLeft,
  ChevronRight,
} from "lucide-react"
import "./ProductsSection.css"


const products = [
  {
    slug: "avery-dennison-reflective-sheeting",
    icon: Layers,
    title: "Avery Dennison Reflective Sheeting",
    image: "/images/products/reflective-sheeting.jpg",
  },
  {
    slug: "reflective-conspicuity-tape",
    icon: Truck,
    title: "Reflective Conspicuity Tape",
    image: "/images/products/conspicuity-tape.jpg",
  },
  {
    slug: "solar-cats-eyes",
    icon: Sun,
    title: "Solar Cat's Eyes",
    image: "/images/products/solar-cats-eyes.jpg",
  },
  {
    slug: "rayolite-marker-road-studs",
    icon: MapPin,
    title: "Rayolite Marker Road Studs",
    image: "/images/products/rayolite-marker.jpg",
  },
  {
    slug: "flexible-delineator-posts",
    icon: GitCommitVertical,
    title: "Flexible Delineator Posts",
    image: "/images/products/delineator-posts.jpg",
  },
  {
    slug: "sma-crash-cushions",
    icon: ShieldAlert,
    title: "SMA Crash Cushions",
    image: "/images/products/sma-crash-cushion.jpg",
  },
  {
    slug: "scorpion-truck-mounted-attenuators",
    icon: ShieldAlert,
    title: "Scorpion Truck-Mounted Attenuators",
    image: "/images/products/scorpion-attenuator3.jpg",
  },
  {
    slug: "delta-grx-retroreflectometer",
    icon: Gauge,
    title: "Delta GRX Retroreflectometer",
    image: "/images/products/delta-grx.jpg",
  },
  {
    slug: "ltl-3500-retroreflectometer",
    icon: PaintBucket,
    title: "LTL 3500 Paint Retroreflectometer",
    image: "/images/products/ltl-3500.jpg",
  },
]

export function ProductsSection() {
  const { t, i18n } = useTranslation()
  const isArabic = i18n.resolvedLanguage === "ar"
  const trackRef = useRef(null)
  const [activeIndex, setActiveIndex] = useState(0)

  // Auto-advance the mobile slider every 3s, same pattern as the hero slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % products.length)
    }, 3000)
    return () => clearInterval(timer)
  }, [])

  // Scroll the active card into view whenever the index changes
  useEffect(() => {
  const track = trackRef.current
  if (!track) return

  const card = track.children[activeIndex]
  if (!card) return

  track.scrollTo({
    left: card.offsetLeft,
    behavior: "smooth",
  })
}, [activeIndex])

  const goToPrev = () => {
    setActiveIndex((prev) => (prev - 1 + products.length) % products.length)
  }

  const goToNext = () => {
    setActiveIndex((prev) => (prev + 1) % products.length)
  }

  return (
        <section id="products" className="products">        <div className="container">
        <div className="products__header">
          <span className="eyebrow">{t("Our Products")}</span>
          <h2 className="products__title">
            {t("Everything you need for road safety")}
          </h2>
          <p className="products__subtitle">
            {t("We supply and install a complete range of road safety equipment from leading global manufacturers.")}
          </p>
        </div>

        <div className="products__grid" ref={trackRef}>
          {products.map((item) => {
            const Icon = item.icon
            return (
              <a
                key={item.slug}
                href={`/products/${item.slug}`}
                className="products__card"
              >
                <div className="products__card-media-wrap">
                  <div className="products__card-media">
                    <img src={item.image} alt={t(item.title)} />
                  </div>
                  <span className="products__card-badge">
                    <Icon size={22} />
                  </span>
                </div>
                <h3 className="products__card-title">{t(item.title)}</h3>
              </a>
            )
          })}
        </div>

        {/* Mobile-only slide navigation, same treatment as the hero arrows */}
        <div className="products__nav">
          <button
            type="button"
            onClick={goToPrev}
            aria-label={t("Previous product")}
            className="products__nav-btn"
          >
            {isArabic ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
          </button>
          <button
            type="button"
            onClick={goToNext}
            aria-label={t("Next product")}
            className="products__nav-btn"
          >
            {isArabic ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
          </button>
        </div>
      </div>
    </section>
  )
}